import { CheckCircle2, Circle, XCircle } from 'lucide-react';
import { HStack, Icon, Text } from '@chakra-ui/react';
import { t } from '@lingui/core/macro';

import { iconSize } from '@duke-hq/ui/constants/scalable';
import type { MarkingStatus } from './types';

const STATUS_STYLES = {
  CORRECT: { color: 'green.600', borderColor: 'green.300', icon: CheckCircle2 },
  REVISION: { color: 'red.600', borderColor: 'red.300', icon: XCircle },
  UNAVAILABLE: { color: 'fg.muted', borderColor: 'border.default', icon: Circle },
};

export function MarkingStatusBadge({
  status,
  correctLabel,
  incorrectLabel,
}: {
  status: MarkingStatus;
  correctLabel: string;
  incorrectLabel: string;
}) {
  const { color, borderColor, icon } = STATUS_STYLES[status];

  let label: string;
  if (status === 'REVISION') {
    label = incorrectLabel;
  } else if (status === 'CORRECT') {
    label = correctLabel;
  } else {
    label = t`Not yet marked`;
  }

  return (
    <HStack
      borderWidth="1px"
      borderColor={borderColor}
      color={color}
      borderRadius="md"
      gap={2}
      px={3}
      h="100%"
      w="100%"
      justify="center"
    >
      <Icon as={icon} boxSize={iconSize.md} />
      <Text fontSize="sm" fontWeight="medium">
        {label}
      </Text>
    </HStack>
  );
}
